import { render, staticRenderFns } from "./Scrollspy.vue?vue&type=template&id=0b58eb35"
import script from "./Scrollspy.vue?vue&type=script&lang=js"
export * from "./Scrollspy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports